import { SystemColor, SystemColorType } from 'icreate/common/models/system-color';

export class SystemColorContainerType {
    title: string;
    description: string;
    color: SystemColor[];
    type: SystemColorType;
}

export const systemColorContainerData: SystemColorContainerType[] = [
    {
        title: 'system-color.alarm.title',
        type: SystemColorType.Alarm,
        description: 'system-color.alarm.description',
        color: [],
    },
    {
        title: 'system-color.sensor.title',
        type: SystemColorType.Sensor,
        description: 'system-color.sensor.description',
        color: [],
    },
    {
        title: 'system-color.digital.title',
        type: SystemColorType.Digital,
        description: 'system-color.digital.description',
        color: [],
    },
    {
        title: 'system-color.valve.title',
        type: SystemColorType.Valve,
        description: 'system-color.valve.description',
        color: [],
    },
];

export const customSystemColorContainerData: SystemColorContainerType = {
    title: 'system-color.custom.title',
    type: SystemColorType.Custom,
    description: 'system-color.custom.description',
    color: [],
};
